import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import Image from 'app/components/Image';

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Spectral&display=swap');
  
  body, html {
    font-family: 'Spectral-Regular', serif;
  }
`;

const Container = styled.div`
  background-color: #f4efe6;
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: 'Spectral-Regular', serif; /* Explicitly set here as well */
`;

const Header = styled.header`
  background-color: #f4efe6;
  height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 2rem;

  @media (max-width: 768px) {
    height: 60px;
    padding: 0 1rem;
  }
`;

const Logo = styled.div`
  width: 120px;
  height: auto;

  img {
    width: 100%;
    height: auto;
  }

  @media (max-width: 768px) {
    width: 100px;
  }
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 0.5rem;

  @media (max-width: 768px) {
    padding: 1rem 0.5rem;
  }
`;

const Title = styled.h1`
  color: #283618;
  font-size: 2rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 1rem;
  max-width: 780px;

  @media (max-width: 768px) {
    font-size: 1.5rem;
    padding: 0 1rem;
  }
`;

const Subtitle = styled.p`
  color: #283618;
  font-size: 1.125rem;
  text-align: left;
  margin-bottom: 2rem;
  max-width: 350px;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 0 1rem;
  }
`;

const UnderlinedText = styled.span`
  text-decoration: underline;
`;

const CalculatorLayout = ({ children, feedback }) => {
  return (
    <>
      <GlobalStyle />
      <Container>
        <Header>
          <Logo>
            <Image src="/assets/images/badi-plus-logo.svg" alt="Badi Plus" />
          </Logo>
        </Header>
        <Content>
          {!feedback ? (
            <>
              <Title>Calcula tu renta con Badi Plus</Title>
              <Subtitle>
                Introduce los detalles de tu propiedad y obtén una{' '}
                <UnderlinedText>estimación de renta</UnderlinedText> en menos de 1 minuto.
              </Subtitle>
            </>
          ) : null}
          {children}
        </Content>
      </Container>
    </>
  );
};

export default CalculatorLayout;
